import React from 'react'
import { useQrCodeGenerator } from 'Hooks/useQrCodeGenerator'
import SheetDataForm from './SheetDataForm'
import QrCodeOptions from './QrCodeOptions'
import ProgressBar from './ProgressBar'
import SheetDataTable from './SheetDataTable'
import QrCodeResultsTable from './QrCodeResultsTable'
import QrCodePreviewModal from './QrCodePreviewModal'

const QrCodeGenerator: React.FC = () => {
  const {
    formData,
    state,
    qrCodeContainerRef,
    updateFormData,
    fetchSheetData,
    generateQRCodes,
    handleDownloadQRCodes,
    handleTableChange,
    handlePreview,
    closePreview
  } = useQrCodeGenerator()

  return (
    <div className="w-full px-8 py-3 bg-gray-50 min-h-screen">
      <style>
        {`
          .checker-bg {
            background-image: linear-gradient(45deg, #f0f0f0 25%, transparent 25%),
                             linear-gradient(-45deg, #f0f0f0 25%, transparent 25%),
                             linear-gradient(45deg, transparent 75%, #f0f0f0 75%),
                             linear-gradient(-45deg, transparent 75%, #f0f0f0 75%);
            background-size: 20px 20px;
            background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
          }
          
          .checker-bg-dark {
            background-image: linear-gradient(45deg, #333 25%, transparent 25%),
                             linear-gradient(-45deg, #333 25%, transparent 25%),
                             linear-gradient(45deg, transparent 75%, #333 75%),
                             linear-gradient(-45deg, transparent 75%, #333 75%);
            background-size: 20px 20px;
            background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
            background-color: #666;
          }
        `}
      </style>
      
      <h1 className="text-2xl font-bold mb-6 text-center text-blue-600 border-b pb-3">
        QR Code Generator
      </h1>
      
      <div className="mt-3 grid grid-cols-1 gap-6">
        <div className="col-span-1">
          {/* Step 1: Input Google Sheet URL */}
          <SheetDataForm
            formData={formData}
            state={state}
            onFormDataChange={updateFormData}
            onFetchSheetData={fetchSheetData}
          />
          
          {/* Step 2: Configure QR Code Options */}
          <QrCodeOptions
            formData={formData}
            state={state}
            onFormDataChange={updateFormData}
            onGenerateQRCodes={generateQRCodes}
          />
          
          {/* Progress Bar */}
          <ProgressBar state={state} />
          
          {/* Sheet Data Table */}
          <SheetDataTable
            state={state}
            onTableChange={handleTableChange}
          />
          
          {/* QR Code Results */}
          <QrCodeResultsTable
            formData={formData}
            state={state}
            qrCodeContainerRef={qrCodeContainerRef}
            onDownloadQRCodes={handleDownloadQRCodes}
            onPreview={handlePreview}
          />
        </div>
      </div>

      {/* QR Code Preview Modal */}
      <QrCodePreviewModal
        formData={formData}
        state={state}
        onClose={closePreview}
      />
    </div>
  )
}

export default QrCodeGenerator 